import './CoffeeSection.css';
import kaffeeImg from '../../assets/images/Kaffee.jpg';

function CoffeeSection() {
  return (
    <section className="coffee">
      <div className="coffee__inner">
        <div className="coffee__content-col">
          <span className="coffee__label">Kaffee</span>
          <h2 className="coffee__title">Privat gerösteter Kaffee</h2>
          <div className="coffee__divider" />
          <p className="coffee__text">
            Morgens um 11:00 Uhr starten wir mit privat geröstetem Kaffee aus Siena
            „handmade" auf einer original La Marzocco-Maschine aus Florenz.
            Trainiert werden unsere Barista von Irma Trülberg, der Deutschen
            Meisterin und Nr. 10 der „World Barista Championship 2016" (Dublin).
          </p>
        </div>
        <div className="coffee__image-col">
          <img src={kaffeeImg} alt="Privat gerösteter Kaffee" className="coffee__image" />
        </div>
      </div>
    </section>
  );
}

export default CoffeeSection;
